import "./SentInterest.css";
import React, { useEffect, useState } from "react";
import { Paper } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { axiosCreateProcess } from "../../Services/ProcessService";
const siteUrl = process.env.REACT_APP_SITE_URL;
const userSite = siteUrl + "/user";

const SentInterest = () => {
  const { candidateId, serviceOrderId } = useParams();

  useEffect(() => {
    if (candidateId == undefined || serviceOrderId == undefined) return;

    try {
      const result = axiosCreateProcess(candidateId, serviceOrderId);
      console.log(
        `Successfully created process for candidate: ${candidateId}, serviceorder: ${serviceOrderId}`,
        result
      );
    } catch (err) {
      console.log(
        `Failed to create process for candidate: ${candidateId}, serviceorder: ${serviceOrderId}`,
        err
      );
    }
  }, []);

  const paperStyle = {
    height: "auto",
    width: "auto",
    maxWidth: "100%",
    margin: "2% 2%",
    boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24)",
    borderRadius: "5px",
  };
  return (
    <div className="container sentinterest-container">
      <Paper style={paperStyle}>
        <div className="col headers-container">
          <div className="row justify-content-end header-row">
            <div className="col-8 logo-header">
              <a href={siteUrl}>
                <img
                  src={require(`../../Images/Icons/Logo.png`)}
                  alt="Image"
                  loading="lazy"
                  className="logo-header-image"
                />
              </a>
            </div>
            <div className="col-2"></div>
          </div>
        </div>
        <div className="col thankyou-text">
          תודה על הגשת מועמדותך!
          <div />
        </div>
        <div className="col image-text-interested" style={{ marginTop: "2%" }}>
          קורות החיים שלך התקבלו בהצלחה. <br />
          הצוות שלנו יעבור על הפרטים
          <br />
          ויחזור אליך בהקדם.
        </div>
        <div className="col main-image">
          <img
            src={require(`../../Images/Shared/ThankYouImage.png`)}
            width="90%"
            height="100%"
          />
        </div>
        <div className="col image-text-interested">
          <b>מחפש/ת עוד הזדמנויות?</b>
          <br />
          ייתכן שיש משרות נוספות שיכולות
          <br />
          להתאים לך.
          <br />
          <br />
        </div>
        <div className="col footer-text container">
          <a href={siteUrl}>
            <div className="blue-text more-jobs">
              <u>
                לצפייה במשרות<i className="description-arrow left"></i>
              </u>
            </div>
          </a>
        </div>
      </Paper>
    </div>
  );
};

export default SentInterest;
